export default "__VITE_ASSET__0wzT5HjL__"